import {
  Outlet,
  useNavigate,
  useLocation,
  useLoaderData,
  redirect,
} from "react-router-dom";
import menu from "../../utils/menu";
import { useContext, useEffect, useState } from "react";
import {
  HambergerMenu,
  SearchNormal,
  Notification,
  ArrowLeft,
  LogoutCurve,
  ArrowDown2,
  ArrowUp2,
} from "iconsax-react";
import { deleteToken, getToken } from "../../utils/token";
import instance, { url } from "../../axios/instance";
import { PRIMARY_COLOR } from "../../utils/theme/getPrimaryColor";
import { ThemeContext } from "../../context/ThemeContext";
import FacilitySelector from "../../components/FacilitySelector";

export const containerLoader = async () => {
  const token = getToken();
  try {
    const res = await instance.get("/doctor", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (res.data.account_status === "deactivated") {
      return redirect("/deactivated");
    }

    const notifs = await instance.get("/doctor/notifications", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const msgs = await instance.get("/doctor/messages", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const rrs = await instance.get("/doctor/refill/pending", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const facility = await instance.get("/doctor/facility", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const linkedFacilities = await instance.get("/doctor/facilities", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const apiKeys = await instance.get("/doctor/api_keys/check", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const plan = await instance.get("/doctor/billing/plan/active", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return {
      doctor: res.data,
      notifs: notifs.data.filter((_) => _.status === "new"),
      msgs: plan.data.noAccess.includes("in-app-chat")
        ? []
        : msgs.data.filter((_) => _.status === "unread"),
      refillRequests: rrs.data,
      facility: facility.data,
      facilities: linkedFacilities.data,
      apiKeys: apiKeys.data,
      plan: plan.data,
    };
  } catch (error) {
    deleteToken();
    return redirect("/auth/login");
  }
};

export default function DashboardContainer() {
  const { doctor, notifs, msgs, refillRequests, facility, facilities, plan } =
    useLoaderData();
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(false);
  const { setThemeColor } = useContext(ThemeContext);
  const location = useLocation();

  function toggleMenuCollapse() {
    setIsMenuCollapsed(!isMenuCollapsed);
  }

  function closeMenu() {
    if (!isMenuCollapsed && window.innerWidth <= 768) {
      setIsMenuCollapsed(true);
    }
  }

  useEffect(() => {
    console.log("The facility theme is ", facility.theme_color);

    const currentTheme = window.localStorage.getItem(PRIMARY_COLOR);

    if (!currentTheme) {
      console.log("I will set current theme");
      setThemeColor(facility.theme_color);
    }

    if (currentTheme !== facility.theme_color) {
      console.log(
        "I am already the old theme so I wont change. change me to !== to trigger update",
      );
      setThemeColor(facility.theme_color);
    }

    if (window.innerWidth <= 1024) {
      setIsMenuCollapsed(true);
    }
  }, []);

  return (
    <div className="font-body font-normal">
      <div onClick={closeMenu} className="h-[100vh]">
        <div
          className={`${
            isMenuCollapsed
              ? "grid grid-cols-[70px_calc(100%_-_70px)]"
              : "grid grid-cols-[70px_calc(100%_-_70px)] lg:grid-cols-[250px_calc(100%_-_250px)]"
          } h-full`}
        >
          {!isMenuCollapsed && <div className="lg:hidden">..</div>}
          <SideNav
            isMenuOpen={!isMenuCollapsed}
            toggleMenu={toggleMenuCollapse}
            isAdmin={doctor.access === "admin"}
            notifs={notifs}
            msgs={msgs}
            refillRequests={refillRequests}
            facilities={facilities}
            facility={facility}
            plan={plan}
          />
          {/* <div className="bg-[#fafafa]"> */}
          <div className="max-h-[100vh] overflow-y-scroll">
            <Outlet />
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
}

function SideNav(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [expandedMenus, setExpandedMenus] = useState({});

  const toggleSubmenu = (menuId) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [menuId]: !prev[menuId],
    }));
  };

  const getMenu = (section) => {
    const sectionMenu = menu.filter((menu) => menu.section === section);
    if (!props.isAdmin) {
      return sectionMenu.filter((menu) => !menu.adminOnly);
    }
    return sectionMenu;
  };

  const logOut = async () => {
    await goOffline();
    deleteToken();
    window.location.href = `/clinic/auth/login`;
    //navigate("/auth/login");
  };

  const token = window.sessionStorage.getItem("ACCESS_TOKEN");

  async function goOffline() {
    instance
      .get("/telemedicine/go_offline", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error.response.data);
      });
  }

  // effect for logo collection
  useEffect(() => {
    if (!props.facility.logo_path) {
      window.localStorage.setItem("CLINIC_LOGO", null);
    } else {
      window.localStorage.setItem(
        "CLINIC_LOGO",
        `${url}${props.facility.logo_path}`,
      );
    }
  }, []);

  return (
    <div
      className={`${
        !props.isMenuOpen ? "relative max-w-[70px] mx-auto" : ""
      } pb-6 px-3 transition-all bg-white border-r left-0 bottom-0 top-0 ${
        props.isMenuOpen ? "fixed lg:relative w-[250px] z-20" : "w-[70px]"
      } max-h-[100vh]`}
    >
      <div>
        <div className="pt-6 pb-3 mb-3 border-b border-[#eee] relative -mx-3">
          <div className="flex justify-between align-items px-4">
            {props.isMenuOpen && (
              <img
                src={
                  props.facility.logo_path
                    ? `${url}${props.facility.logo_path}`
                    : "/clinic/images/logo1.png"
                }
                width={150}
                height={50}
              />
            )}
            <div
              onClick={props.toggleMenu}
              className="w-8 h-8 flex items-center justify-center rounded-full bg-primary cursor-pointer hover:opacity-80 duration-300"
            >
              <ArrowLeft
                size={20}
                color="white"
                className={props.isMenuOpen ? "" : "-scale-x-100"}
              />
            </div>
          </div>
        </div>

        <div className="overflow-y-scroll h-[75vh] pb-20 scrollbar-hide">
          <ul className="border-b border-[#eee] py-3">
            {getMenu(1).map((item, index) => (
              <LinkItem
                isActive={location.pathname.includes(item.path) ? true : false}
                key={item.id}
                title={item.title}
                icon={item.icon}
                onClick={() => navigate(item.path)}
                iconsOnly={!props.isMenuOpen}
                lastItem={getMenu(1).length - 1 === index}
              />
            ))}
          </ul>
          <ul className="border-b border-[#eee] py-3">
            {getMenu(2).map((item, index) => (
              <LinkItem
                isActive={location.pathname.includes(item.path) ? true : false}
                key={item.id}
                title={item.title}
                icon={item.icon}
                onClick={() => navigate(item.path)}
                iconsOnly={!props.isMenuOpen}
                action_required={item.action && props[item.action]?.length > 0}
                lastItem={getMenu(2).length - 1 === index}
              />
            ))}
          </ul>
          <ul className="py-3">
            {getMenu(3).map((item, index) => (
              <div key={item.id}>
                <LinkItem
                  isActive={
                    location.pathname.includes(item.path) ? true : false
                  }
                  title={item.title}
                  icon={item.icon}
                  onClick={() =>
                    item.hasSubmenu
                      ? toggleSubmenu(item.id)
                      : navigate(item.path)
                  }
                  iconsOnly={!props.isMenuOpen}
                  lastItem={!item.hasSubmenu && getMenu(3).length - 1 === index}
                  hasSubmenu={item.hasSubmenu}
                  isExpanded={expandedMenus[item.id]}
                />
                {item.hasSubmenu &&
                  expandedMenus[item.id] &&
                  props.isMenuOpen && (
                    <ul className="ml-4 mt-1 space-y-1">
                      {item.submenu.map((subitem, subindex) => (
                        <LinkItem
                          key={subitem.id}
                          isActive={location.pathname.includes(subitem.path)}
                          title={subitem.title}
                          icon={subitem.icon}
                          onClick={() => navigate(subitem.path)}
                          iconsOnly={false}
                          isSubmenu={true}
                          lastItem={
                            item.submenu.length - 1 === subindex &&
                            getMenu(3).length - 1 === index
                          }
                        />
                      ))}
                    </ul>
                  )}
              </div>
            ))}
          </ul>
        </div>
      </div>
      <div
        className={`absolute bottom-0 left-0 right-0 bg-gray-50 py-6 px-2 grid grid-cols-1 gap-y-2 items-center`}
      >
        <FacilitySelector
          facilities={props.facilities}
          facility={props.facility}
          isMenuOpen={props.isMenuOpen}
        />
        <button
          className={`bg-white w-full h-12 hover:border-[#FF8A65] duration-300 cursor-pointer border flex justify-center gap-x-3 items-center rounded-md disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:border-[#eee] px-4 text-sm`}
          onClick={logOut}
        >
          {props.isMenuOpen && "Log out"}
          <LogoutCurve
            size="20"
            color="#FF8A65"
            style={{ marginRight: "5px" }}
          />{" "}
        </button>
      </div>
    </div>
  );
}

function LinkItem(props) {
  return (
    <li
      onClick={props.onClick}
      className={`border-2 rounded-md ${
        props.isActive
          ? "text-black border-primary-light"
          : "border-white hover:border-primary-light"
      } ${props.isSubmenu ? "text-[13px]" : "text-[14px]"} flex gap-2 items-center justify-between px-2 ${
        props.lastItem ? "" : "mb-2.5"
      } py-1.5 text-gray-700 cursor-pointer`}
    >
      <div className="flex gap-2 items-center">
        <div
          className={`relative ${
            props.isActive ? "text-primary" : null
          } group-hover:text-primary ${
            props.iconsOnly ? "max-w-[70px] mx-auto h-auto" : ""
          }`}
        >
          {props.action_required && (
            <span className="w-[5px] h-[5px] rounded-full bg-[tomato] absolute top-0 right-0"></span>
          )}
          {props.icon}
        </div>
        {!props.iconsOnly && props.title}
      </div>
      {props.hasSubmenu && !props.iconsOnly && (
        <div className="text-gray-500">
          {props.isExpanded ? <ArrowUp2 size={16} /> : <ArrowDown2 size={16} />}
        </div>
      )}
    </li>
  );
}
